import React from "react";
import {useDispatch, useSelector } from "react-redux";
import {trackUserEvent} from  'src/shared/database_actions.jsx'
import { defaultPublicTrackingUrl } from 'src/shared/urls.jsx'
import Cookies from 'js-cookie'

const getMyCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const hasIotCookieConsent = () => {
  const optanonConsentCookie = getMyCookie("OptanonConsent")

  if (optanonConsentCookie) {
    // URL-decodiert ergibt das diesen String: 1:1,2:1,3:1,4:1,8:1
    // 1 – erforderlich, immer 1
    // 2 – „Leistungscookies“ (Tracking)
    // 3 – „Funktionelle Cookies“ (v.a. Personalisierung)
    // 4 – Marketing
    // 8 – Social Media

    const urlParams = new URLSearchParams(decodeURIComponent(optanonConsentCookie));
    const groups = urlParams.get("groups")

    if (groups) {
      return groups.split(",").some(group => group.split(":")[0] === "2" && group.split(":")[1] === "1")
    }
  }

  return false
}

/**
 * Creates a hook, for user event tracking, which returns a function that can be used to send tracking events.
 *
 * @param googleAnalyticsTracking Boolean which defaults to true, if set to false google analytic tracking will be disabled (if enabled window.gtag needs to be set aswell)
 *
 * There are two kinds of trackings:
 * 1. Tracking flave internally which just adds tracking events to the store (which then are sent later).
 * 2. Sends google analytic events trough window.gtag (if not defined no google analytic events will be sent.
 *
 * The returned function/hook has the following parameters:
 * @param trackingSource Source of tracking or the event type as string e.g. "click", "interaction" - you are free to use any value for the trackingSource
 * @param additionalData Are additional data, which is used by flave backend, in the Tracking model - note that only dara which are handled are saved other parameters will be ignored.
 * @param analyticsData This are parameters which will be sent to google analytics, for further information look at https://developers.google.com/analytics/devguides/collection/gtagjs/events
 * @param googleAnalyticsTracking Boolean which defaults to true, if set to false google analytic tracking will be disabled (if enabled window.gtag needs to be set aswell)
 *
 *
 * @example
 * import React, { useCallback } from 'react'
 * import { useTracking } from '.../use_tracking'
 *
 * export const myComponent = () => {
 *   const track = useTracking()
 *
 *   const hotspot = .....
 *   const hotspotConfig = .....
 *   const currentSlideshowImage = ...
 *
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={() => {
 *         track("hotspot_click", {hotspot_id: hotspot.id, slideshowImageId: currentSlideshowImage?.id}, {event_label: hotspotConfig?.title})
 *       }>Track this click</button>
 *     </div>
 *   )
 * }
 *
 *
 * @returns Track hook
 */
export function useTracking(googleAnalyticsTracking = true) {
  
  const dispatch = useDispatch()
  const hostname = useSelector(state => state.hostname)
  const googleAnalyticsTrackingGlobal = googleAnalyticsTracking
  const useCookieStore = useSelector(state => state.serverSettings?.tracking_cookie_store)
  const gdprConfirmation = useSelector(state => useCookieStore ? (state.gdprConfirmation || Cookies.get("gdprstatus") == "true") : state.gdprConfirmation)
  //console.log("INITIALIZE", gdprConfirmation, useCookieStore, Cookies?.get("gdprstatus")?.toString())
  const gdprConfirmationRequired = useSelector(state => state.serverSettings?.tracking_gdpr_required || state.gdprConfirmationRequired == true)
  //console.log({gdprConfirmationRequired, gdprConfirmation, useCookieStore}, Cookies.get("gdprstatus") == "true")
  const tagOwner = useSelector(state => state.tagOwner)
  const trackingUrl = useSelector(state => state.trackingUrl || defaultPublicTrackingUrl).replace("@tag_owner_id@", tagOwner?.id)

  const developers = ["mk@flave.at", "dg@flave.at", "al@flave.at", "pl@flave.at", "tc@flave.at", "gh@flave.at", "sb@flave.at"]

  return function track(trackingSource, additionalData, analyticsData, googleAnalyticsTracking = true) {

    if (hostname === "flaveiot20" && !hasIotCookieConsent()) {
      console.warn("useTracking", "ignoring tracking to insufficient a1 cookie consent.")
      return false
    }

    if(!trackingUrl) {
      console.error("NO TRACKING URL PROVIDED. track(..) aborted! FIX THIS!")
      if(tagOwner && developers.indexOf(tagOwner.email) >= 0) {
        alert("NO TRACKING URL PROVIDED. track(..) aborted! FIX THIS!")
      }
      return false
    }
    //console.warn("track", {gdprConfirmation, useCookieStore}, Cookies.get("gdprstatus"), !gdprConfirmationRequired || gdprConfirmation)

    if(gdprConfirmationRequired && useCookieStore && Cookies.get("gdprstatus") != "true") {
      console.warn("Not tracking due to cookie store and declined status", Cookies.get("gdprstatus"))
      return false
    }

    if (!gdprConfirmationRequired || gdprConfirmation) {
      if(!gdprConfirmationRequired || (gdprConfirmation === true || gdprConfirmation.tracking_accepted)) {
        console.debug("useTracking", {trackingSource, additionalData, analyticsData})
        if (hostname === "flaveueg23") {
          var additionalDataPlus = Object.assign({}, additionalData, { user_roles: { 
            role_week_virtual: tagOwner.role_week_virtual,
            role_week_in_person: tagOwner.role_week_in_person,
            role_pgt_virtual: tagOwner.role_pgt_virtual,
            role_pgt_in_person: tagOwner.role_pgt_in_person,
          }})
          dispatch(trackUserEvent({source: trackingSource, ...additionalDataPlus}))
        } else {
          dispatch(trackUserEvent({source: trackingSource, ...additionalData}))
        }
      } else {
        console.warn("useTracking", "ignoring tracking due to declined gdpr acception")
      }
    } else {
      console.warn("useTracking", "ignoring tracking due to missing gdpr acception")
    }

    if (!gdprConfirmationRequired || gdprConfirmation) {
      if(!gdprConfirmationRequired || (gdprConfirmation === true || gdprConfirmation.google_analytics_tracking_accepted)) {
        if(googleAnalyticsTrackingGlobal && googleAnalyticsTracking && window.gtag) {
          console.debug("useTracking", {googleAnalyticsTracking, googleAnalyticsTrackingGlobal})

          // google analytics unterstützt keine hashes
          // if (hostname === "flaveueg23") {
          //   var analyticsDataPlus = Object.assign({}, analyticsData, { user_roles: { 
          //     role_week_virtual: tagOwner.role_week_virtual,
          //     role_week_in_person: tagOwner.role_week_in_person,
          //     role_pgt_virtual: tagOwner.role_pgt_virtual,
          //     role_pgt_in_person: tagOwner.role_pgt_in_person,
          //   }})
          //   window.gtag('event', trackingSource, analyticsDataPlus || {});
          // } else {
            window.gtag('event', trackingSource, analyticsData || {});
          //}
          
        } 
      } else {
        console.warn("useTracking", "ignoring google analytics due to declined gdpr acception")
      }
    } else {
      console.warn("useTracking", "ignoring google analytics due to missing gdpr acception")
    }
  }
}
